import DefaultParagraph from '@tiptap/extension-paragraph';

export const Paragraph = DefaultParagraph.extend({
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-0': () => this.editor.commands.setParagraph(),
        };
    },
});
